module.exports = __webpack_public_path__ + "img/pilot.5584f177.svg";